import { Directive, ElementRef, Input, OnChanges } from "@angular/core";

@Directive({
  selector: "[abScrollMe]",
})
export class ScrollMeDirective implements OnChanges {
  @Input("abScrollMe") public scrollMe: boolean;

  constructor(private elementRef: ElementRef) {}

  public ngOnChanges() {
    if (!this.scrollMe) {
      return;
    }
    setTimeout(this.scroll.bind(this));
  }

  private scroll() {
    const el = this.elementRef.nativeElement;
    if (!el.parentNode || !el.parentNode.parentNode) {
      return;
    }
    const container = el.parentNode.parentNode;

    // Check if element is located under the container.
    const offsetBottom =
      el.offsetTop + el.clientHeight - container.clientHeight;
    if (offsetBottom > container.scrollTop) {
      container.scrollTop = offsetBottom + 1;
      return;
    }

    // Check if element is located above the container.
    const offsetTop = el.offsetTop - container.offsetTop;
    if (offsetTop < container.scrollTop) {
      container.scrollTop = offsetTop - 1;
      return;
    }
  }
}
